import { Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { VerificationTable } from '../VerificationTable/VerificationTable';
import { messages } from './StepForm.messages';

export const StepForm = memo(() => {
    return (
        <>
            <Text font='body' fontSize='medium'>
                {messages.provideVerificationData}
            </Text>

            <VerificationTable />
        </>
    );
});

StepForm.displayName = 'StepForm';
